import { Fragment, VoidFunctionComponent } from 'react';
import { Icon } from 'components/elements';
import { getRouteById } from 'lib/routes';
import {
  BreadcrumbsBranch,
  BreadcrumbsChevron,
  BreadcrumbsHome,
  BreadcrumbsLeaf,
  StyledBreadcrumbs,
} from './Breadcrumbs.styled';
import { BreadcrumbsProps } from './types';

export const Breadcrumbs: VoidFunctionComponent<BreadcrumbsProps> = props => {
  const { entries } = props;

  // Retrieve route configuration for each entry
  const routes = entries.map(entry => getRouteById(entry.id));

  // Ensure the final leaf node exists
  const current = routes.pop();
  if (!current) {
    return null;
  }

  return (
    <StyledBreadcrumbs>
      <BreadcrumbsHome routeId="accounts:list">
        <Icon name="home" />
      </BreadcrumbsHome>
      <BreadcrumbsChevron>
        <Icon name="chevron right" />
      </BreadcrumbsChevron>
      {routes.map((route, index) => (
        <Fragment key={route.id}>
          <BreadcrumbsBranch key={route.id} routeId={route.id} routeParams={entries[index]?.params}>
            {route.title}
          </BreadcrumbsBranch>
          <BreadcrumbsChevron>
            <Icon name="chevron right" />
          </BreadcrumbsChevron>
        </Fragment>
      ))}
      <BreadcrumbsLeaf>{current.title}</BreadcrumbsLeaf>
    </StyledBreadcrumbs>
  );
};
